var React = require('react');

function IconCloseInline (props) {
    return React.createElement("path",props);
}

IconCloseInline.defaultProps = {"d":"M45.9573379,1.07830868 C44.5671217,-0.311907471 42.3213879,-0.311907471 40.9311718,1.07830868 L23.5,18.4738339 L6.06882821,1.04266212 C4.67861206,-0.347554039 2.43287827,-0.347554039 1.04266212,1.04266212 C-0.347554039,2.43287827 -0.347554039,4.67861206 1.04266212,6.06882821 L18.4738339,23.5 L1.04266212,40.9311718 C-0.347554039,42.3213879 -0.347554039,44.5671217 1.04266212,45.9573379 C2.43287827,47.347554 4.67861206,47.347554 6.06882821,45.9573379 L23.5,28.5261661 L40.9311718,45.9573379 C42.3213879,47.347554 44.5671217,47.347554 45.9573379,45.9573379 C47.347554,44.5671217 47.347554,42.3213879 45.9573379,40.9311718 L28.5261661,23.5 L45.9573379,6.06882821 C47.3119075,4.71425863 47.3119075,2.43287827 45.9573379,1.07830868 Z"};

module.exports = IconCloseInline;

IconCloseInline.default = IconCloseInline;
